(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["branches"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const searchInput = document.getElementById('branchSearchInput');
    const clearBtn = document.getElementById('clearBranchSearch');
    const cityChips = document.querySelectorAll('.city-chip');
    const cards = document.querySelectorAll('.branch-card');
    const tableRows = document.querySelectorAll('.branches-data-table tbody tr');
    const emptyState = document.getElementById('noBranchesFound');
    const resetBtn = document.getElementById('resetBranchesFilter');

    let activeCity = 'all';
    let searchQuery = '';

    function filterBranches() {
      let visibleCount = 0;
      const query = searchQuery.trim().toLowerCase();

      cards.forEach((card) => {
        const city = (card.getAttribute('data-city') || '').toLowerCase();
        const store = (card.getAttribute('data-store') || '').toLowerCase();
        const address = (card.getAttribute('data-address') || '').toLowerCase();
        const phones = (card.getAttribute('data-phones') || '').toLowerCase();

        const matchCity = (activeCity === 'all') || city.includes(activeCity.toLowerCase());
        const matchSearch = !query ||
          city.includes(query) ||
          store.includes(query) ||
          address.includes(query) ||
          phones.includes(query);

        if (matchCity && matchSearch) {
          card.style.display = 'flex';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      // Filter table rows
      tableRows.forEach((row) => {
        const rowText = row.textContent.toLowerCase();
        const matchCity = (activeCity === 'all') || rowText.includes(activeCity.toLowerCase());
        const matchSearch = !query || rowText.includes(query);

        if (matchCity && matchSearch) {
          row.style.display = '';
        } else {
          row.style.display = 'none';
        }
      });

      if (emptyState) {
        emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        searchQuery = e.target.value;
        if (clearBtn) {
          clearBtn.style.display = searchQuery.length > 0 ? 'block' : 'none';
        }
        filterBranches();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        searchInput.value = '';
        searchQuery = '';
        clearBtn.style.display = 'none';
        searchInput.focus();
        filterBranches();
      });
    }

    cityChips.forEach((chip) => {
      chip.addEventListener('click', () => {
        cityChips.forEach((c) => c.classList.remove('active'));
        chip.classList.add('active');
        activeCity = chip.getAttribute('data-city') || 'all';
        filterBranches();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        cityChips.forEach((c) => c.classList.remove('active'));
        const allChip = document.querySelector('.city-chip[data-city="all"]');
        if (allChip) allChip.classList.add('active');
        activeCity = 'all';
        if (searchInput) searchInput.value = '';
        searchQuery = '';
        if (clearBtn) clearBtn.style.display = 'none';
        filterBranches();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroBannerSlider {
    constructor(element) {
      this.slider = element;
      this.track = this.slider.querySelector('.hero-slider-track');
      this.slides = Array.from(this.slider.querySelectorAll('.hero-slider-slide'));
      this.dots = Array.from(this.slider.querySelectorAll('.hero-slider-dot'));
      this.prevBtn = this.slider.querySelector('.hero-slider-prev');
      this.nextBtn = this.slider.querySelector('.hero-slider-next');

      this.isAutoplay = this.slider.dataset.autoplay === 'true';
      this.speed = parseInt(this.slider.dataset.speed, 10) || 5000;
      this.pauseOnHover = this.slider.dataset.pauseHover === 'true';

      this.currentIndex = 0;
      this.total = this.slides.length;
      this.timer = null;
      this.isHovered = false;

      // Touch gesture variables
      this.touchStartX = 0;
      this.touchEndX = 0;

      if (this.total <= 0) return;

      this.init();
    }

    init() {
      // Event listeners for Navigation Arrows
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.goToSlide(this.currentIndex - 1);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.goToSlide(this.currentIndex + 1);
        });
      }

      // Event listeners for Dots
      this.dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          this.goToSlide(idx);
        });
      });

      // Hover pause handlers
      if (this.pauseOnHover) {
        this.slider.addEventListener('mouseenter', () => {
          this.isHovered = true;
          this.clearTimer();
        });
        this.slider.addEventListener('mouseleave', () => {
          this.isHovered = false;
          this.scheduleNextTransition();
        });
      }

      // Touch / Swipe support
      this.slider.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.slider.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
      }, { passive: true });

      // Init Video elements and sound toggles
      this.initVideos();

      // Start initial slide handling
      this.activateSlide(0);
    }

    initVideos() {
      this.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        const soundBtn = slide.querySelector('.hero-video-sound-toggle');

        if (video) {
          // Listen for video ended event to move immediately to next slide
          video.addEventListener('ended', () => {
            this.goToSlide(this.currentIndex + 1);
          });

          // Sound toggle button
          if (soundBtn) {
            soundBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              e.preventDefault();
              video.muted = !video.muted;
              const mutedIcon = soundBtn.querySelector('.sound-icon-muted');
              const unmutedIcon = soundBtn.querySelector('.sound-icon-unmuted');
              if (mutedIcon && unmutedIcon) {
                if (video.muted) {
                  mutedIcon.style.display = 'block';
                  unmutedIcon.style.display = 'none';
                } else {
                  mutedIcon.style.display = 'none';
                  unmutedIcon.style.display = 'block';
                }
              }
            });
          }
        }
      });
    }

    handleSwipe() {
      const diff = this.touchEndX - this.touchStartX;
      const threshold = 45; // min px for swipe

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          // Swiped right -> go to previous
          this.goToSlide(this.currentIndex - 1);
        } else {
          // Swiped left -> go to next
          this.goToSlide(this.currentIndex + 1);
        }
      }
    }

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

    goToSlide(index) {
      if (this.total <= 1) return;
      this.clearTimer();

      const newIndex = (index + this.total) % this.total;
      this.activateSlide(newIndex);
    }

    activateSlide(index) {
      // Pause all previous videos
      this.slides.forEach((slide, idx) => {
        slide.classList.remove('is-active');
        const video = slide.querySelector('video');
        if (video) {
          video.pause();
          if (idx !== index) {
            video.currentTime = 0;
          }
        }
      });

      this.currentIndex = index;
      const activeSlide = this.slides[this.currentIndex];
      activeSlide.classList.add('is-active');

      // Update Track transform (sliding animation)
      if (this.track) {
        this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      }

      // Update Dots state
      this.dots.forEach((dot, idx) => {
        const isActive = idx === this.currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Handle Current Slide Media Playback & Transition
      this.handleCurrentSlidePlayback(activeSlide);
    }

    handleCurrentSlidePlayback(activeSlide) {
      const slideType = activeSlide.dataset.type;
      const video = activeSlide.querySelector('video');

      if (slideType === 'video_slide' && video) {
        // Play video
        video.currentTime = 0;
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // Autoplay with sound or codec fallback: keep muted and retry
            video.muted = true;
            video.play().catch(() => {});
          });
        }

        // Safety fallback: if video duration is NaN or fails, fallback to timer
        const checkDurationTimer = setTimeout(() => {
          if (isNaN(video.duration) || video.duration === 0) {
            this.scheduleNextTransition(this.speed);
          }
        }, 2000);

        video.addEventListener('loadedmetadata', () => {
          clearTimeout(checkDurationTimer);
        }, { once: true });

      } else {
        // Regular Image slide: schedule timer
        this.scheduleNextTransition(this.speed);
      }
    }

    scheduleNextTransition(customSpeed) {
      if (!this.isAutoplay || this.total <= 1 || this.isHovered) return;
      this.clearTimer();

      const delay = customSpeed || this.speed;
      this.timer = setTimeout(() => {
        this.goToSlide(this.currentIndex + 1);
      }, delay);
    }
  }

  // Initialize all instances
  function initHeroSliders() {
    document.querySelectorAll('.hero-banner-slider-wrapper').forEach((el) => {
      new HeroBannerSlider(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSliders);
  } else {
    initHeroSliders();
  }

  // Support Shopify Theme Customizer Live Preview
  document.addEventListener('shopify:section:load', function (event) {
    const sectionEl = event.target.querySelector('.hero-banner-slider-wrapper');
    if (sectionEl) {
      new HeroBannerSlider(sectionEl);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.oukitel-hero-slider');
    if (!slider) return;

    const slides = slider.querySelectorAll('.hero-slide');
    const dots = slider.querySelectorAll('.slider-dot');
    const prevBtn = slider.querySelector('.slider-arrow-prev');
    const nextBtn = slider.querySelector('.slider-arrow-next');
    const isAutoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed) || 5000;

    let currentIndex = 0;
    let timer = null;

    function goToSlide(index) {
      slides[currentIndex].classList.remove('active');
      if (dots[currentIndex]) dots[currentIndex].classList.remove('active');

      currentIndex = (index + slides.length) % slides.length;

      slides[currentIndex].classList.add('active');
      if (dots[currentIndex]) dots[currentIndex].classList.add('active');
    }

    if (prevBtn)
      prevBtn.addEventListener('click', () => {
        goToSlide(currentIndex - 1);
        resetTimer();
      });
    if (nextBtn)
      nextBtn.addEventListener('click', () => {
        goToSlide(currentIndex + 1);
        resetTimer();
      });

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        goToSlide(idx);
        resetTimer();
      });
    });

    function startTimer() {
      if (isAutoplay && slides.length > 1) {
        timer = setInterval(() => goToSlide(currentIndex + 1), speed);
      }
    }

    function resetTimer() {
      if (timer) clearInterval(timer);
      startTimer();
    }

    startTimer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const mainMediaFrame = document.querySelector('.main-media-frame');
    const thumbBtns = Array.from(document.querySelectorAll('.thumb-btn'));
    const prevBtn = document.querySelector('.gallery-prev');
    const nextBtn = document.querySelector('.gallery-next');
    const counterSpan = document.getElementById('currentImageNum-{{ section.id }}');
    const waOrderBtn = document.getElementById('WaOrderBtn-{{ section.id }}');

    if (thumbBtns.length > 0 && mainMediaFrame) {
      let currentIndex = 0;

      function setActiveMedia(index) {
        if (index < 0) index = thumbBtns.length - 1;
        if (index >= thumbBtns.length) index = 0;
        currentIndex = index;

        thumbBtns.forEach((b, i) => {
          b.classList.toggle('active', i === currentIndex);
        });

        const activeThumb = thumbBtns[currentIndex];
        if (activeThumb) {
          const mediaType = activeThumb.dataset.mediaType;
          const imageUrl = activeThumb.dataset.imageUrl;
          const videoHtml = activeThumb.dataset.videoHtml;

          if ((mediaType === 'video' || mediaType === 'external_video') && videoHtml) {
            const temp = document.createElement('div');
            temp.innerHTML = videoHtml;
            const newVid = temp.firstElementChild;

            const oldImg = mainMediaFrame.querySelector('.featured-product-image');
            const oldVid = mainMediaFrame.querySelector('.featured-product-video');
            if (oldImg) oldImg.remove();
            if (oldVid) oldVid.remove();

            if (newVid) mainMediaFrame.appendChild(newVid);
          } else if (imageUrl) {
            let mainImg = mainMediaFrame.querySelector('.featured-product-image');
            const oldVid = mainMediaFrame.querySelector('.featured-product-video');
            if (oldVid) oldVid.remove();

            if (!mainImg) {
              mainImg = document.createElement('img');
              mainImg.className = 'featured-product-image';
              mainMediaFrame.appendChild(mainImg);
            }
            mainImg.style.opacity = '0.4';
            mainImg.src = imageUrl;
            mainImg.onload = () => {
              mainImg.style.opacity = '1';
            };
          }

          if (counterSpan) {
            counterSpan.textContent = currentIndex + 1;
          }
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }

      thumbBtns.forEach((btn, index) => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          setActiveMedia(index);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          setActiveMedia(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          setActiveMedia(currentIndex + 1);
        });
      }

      // Touch Swipe Support for Mobile
      const mediaFrame = document.querySelector('.main-media-frame');
      if (mediaFrame) {
        let touchStartX = 0;
        let touchEndX = 0;

        mediaFrame.addEventListener(
          'touchstart',
          (e) => {
            touchStartX = e.changedTouches[0].screenX;
          },
          { passive: true }
        );

        mediaFrame.addEventListener(
          'touchend',
          (e) => {
            touchEndX = e.changedTouches[0].screenX;
            const diff = touchEndX - touchStartX;
            if (Math.abs(diff) > 40) {
              if (diff > 0) {
                // In RTL, swiping right goes to previous media
                setActiveMedia(currentIndex - 1);
              } else {
                setActiveMedia(currentIndex + 1);
              }
            }
          },
          { passive: true }
        );
      }
    }

    // Dynamic Option Pills Selection & WhatsApp Message Sync
    const optionGroups = document.querySelectorAll('.option-group');
    if (optionGroups.length > 0 && waOrderBtn) {
      function updateWhatsAppLink() {
        const selectedOptions = [];
        optionGroups.forEach((group) => {
          const optName = group.dataset.optionName;
          const activePill = group.querySelector('.option-pill-btn.selected');
          if (activePill) {
            selectedOptions.push(`${optName}: ${activePill.dataset.value}`);
          }
        });

        const productTitle = document.querySelector('.product-title')?.textContent?.trim() || '';
        const productPrice = document.querySelector('.current-price')?.textContent?.trim() || '';
        const currentUrl = window.location.href;

        let msg = `مرحباً، أود طلب جهاز أوكتيل التالي:\n الجهاز: ${productTitle}\n💰 السعر: ${productPrice}`;
        if (selectedOptions.length > 0) {
          msg += `\n⚙️ الخيارات: (${selectedOptions.join(' | ')})`;
        }
        msg += `\n🔗 الرابط: ${currentUrl}`;

        const baseHref = waOrderBtn.href.split('?')[0];
        waOrderBtn.href = `${baseHref}?text=${encodeURIComponent(msg)}`;
      }

      optionGroups.forEach((group) => {
        const pills = group.querySelectorAll('.option-pill-btn');
        const valDisplay = group.querySelector('.selected-option-value');

        pills.forEach((pill) => {
          pill.addEventListener('click', function () {
            pills.forEach((p) => p.classList.remove('selected'));
            this.classList.add('selected');
            if (valDisplay) {
              valDisplay.textContent = this.dataset.value;
            }
            updateWhatsAppLink();
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function shuffleCards(container) {
    if (!container) return;
    const isRandom = container.getAttribute('data-random') === 'true';
    if (!isRandom) return;

    const cards = Array.from(container.children).filter(function (c) {
      return c.classList && c.classList.contains('showcase-card');
    });
    if (cards.length <= 1) return;

    for (let i = cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      container.appendChild(cards[j]);
    }
  }

  const grid = document.getElementById('showcase-grid');
  if (grid) {
    shuffleCards(grid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      const g = document.getElementById('showcase-grid');
      if (g) shuffleCards(g);
    });
  }

  // =============================================
  // INFINITE SCROLL — IntersectionObserver
  // =============================================
  const sentinel = document.getElementById('load-more-sentinel');

  if (sentinel) {
    let isFetching = false;

    async function loadMoreProducts() {
      if (isFetching) return;
      const nextUrl = sentinel.getAttribute('data-next-url');
      if (!nextUrl) return;

      isFetching = true;
      sentinel.classList.add('is-loading');

      try {
        const response = await fetch(nextUrl);
        const text = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        let newCards = Array.from(doc.querySelectorAll('.showcase-card'));
        const showcaseGrid = document.getElementById('showcase-grid');

        if (showcaseGrid && showcaseGrid.getAttribute('data-random') === 'true') {
          for (let i = newCards.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const temp = newCards[i];
            newCards[i] = newCards[j];
            newCards[j] = temp;
          }
        }

        // Append new cards with fade-in animation
        newCards.forEach((card, i) => {
          card.style.opacity = '0';
          card.style.transform = 'translateY(24px)';
          if (showcaseGrid) showcaseGrid.appendChild(card);
          requestAnimationFrame(() => {
            setTimeout(() => {
              card.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
              card.style.opacity = '1';
              card.style.transform = 'translateY(0)';
            }, i * 60);
          });
        });

        // Check if there is a next page
        const newSentinel = doc.getElementById('load-more-sentinel');
        if (newSentinel) {
          sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
        } else {
          // No more pages — remove sentinel so observer stops
          observer.unobserve(sentinel);
          sentinel.remove();
          return;
        }

      } catch (err) {
        console.error('Infinite scroll error:', err);
      } finally {
        isFetching = false;
        sentinel.classList.remove('is-loading');
      }
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) loadMoreProducts();
      });
    }, { rootMargin: '200px' });

    observer.observe(sentinel);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
